<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['userName', validatorRules.userName]"
            placeholder="请选择用户"
            readonly
            @click="openSelectUser"
          ></a-input>
        </a-form-item>
        <a-form-item v-show="false" label="用户工号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readonly v-decorator="['userCode', validatorRules.userCode]" @click="openSelectUser"></a-input>
        </a-form-item>
        <a-form-item label="是否开启通知" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group buttonStyle="solid" v-decorator="['noticeFlag', validatorRules.noticeFlag]" dictCode="on_off">
            <a-radio-button value="1">启动</a-radio-button>
            <a-radio-button value="0">关闭</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['title', validatorRules.title]" rows="4" placeholder="请输入标题" />
        </a-form-item>
        <a-form-item label="通知内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['notice', validatorRules.notice]" rows="4" placeholder="请输入通知内容" />
        </a-form-item>
        <a-form-item label="app编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            v-decorator="['url', validatorRules.url]"
            :triggerChange="true"
            placeholder="请选择APP编码"
            dictCode="bus_data_center_configuration"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <select-user-modal
      ref="selectUserModal"
      :onlySelectOne="true"
      @selectChoosed="handleSelectChoosed"
    ></select-user-modal>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import SelectUserModal from './SelectUserModal'

export default {
  name: 'BusDataCenterConfigurationModal',
  components: {
    SelectUserModal,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        userName: { rules: [{ required: true, message: '请输入选择用户名!' }] },
        userCode: { rules: [] },
        title: { rules: [{ required: true, message: '请输入标题!' }] },
        noticeFlag: { rules: [{ required: true, message: '请确认是否启用!' }], initialValue: '1' },
        notice: { rules: [{ required: true, message: '请输入通知内容!' }] },
        url: { rules: [{ required: true, message: '请输入app编码!' }] },
      },
      url: {
        add: '/busDataCenterConfiguration/add',
        edit: '/busDataCenterConfiguration/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'userName', 'userCode', 'noticeFlag', 'notice', 'url', 'title'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    openSelectUser() {
      this.$refs.selectUserModal.add()
    },
    handleSelectChoosed(objData) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          userName: objData[0].realname,
          userCode: objData[0].username,
        })
      })
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }
          let formData = Object.assign(this.model, values)
          console.log(formData.noticeFlag)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>